import React from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../config/msalConfig';

const LoginPage = () => {
  const { instance } = useMsal();

  const handleLogin = async () => {
    try {
      await instance.loginPopup(loginRequest);
      // Dispatch custom event to notify parent component
      window.dispatchEvent(new CustomEvent('accounts-updated'));
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  return (
    <div className="container-fluid vh-100 d-flex align-items-center justify-content-center">
      <div className="row justify-content-center w-100">
        <div className="col-md-6 col-lg-4">
          <div className="card shadow">
            <div className="card-body text-center p-5">
              <div className="mb-4">
                <i className="ri-microsoft-line" style={{ fontSize: '4rem', color: '#0078d4' }}></i>
              </div>
              <h3 className="card-title mb-3">Teams Meeting Dashboard</h3>
              <p className="text-muted mb-4">
                Inicia sesión con tu cuenta de Microsoft para ver tus reuniones de Teams
              </p>
              <button
                onClick={handleLogin}
                className="btn btn-primary btn-lg w-100"
              >
                <i className="ri-microsoft-line me-2"></i>
                Iniciar sesión con Microsoft
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { LoginPage };
export default LoginPage;